import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { listJobs, listBatches } from '../../actions/superadmin';
import { storeWithExpiration } from '../../utils/common';
import JobsPage from './JobsPage';
import BatchesPage from './BatchesPage';

export class JobsPageContainer extends React.Component {
  static propTypes = {
    listJobsAction: PropTypes.func.isRequired,
    listBatchesAction: PropTypes.func.isRequired,
    superadmin: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    const { listJobsAction } = this.props;
    const token = storeWithExpiration.get('token');
    listJobsAction(token);
  };

  getJobBatches = jobId => {
    const { listBatchesAction } = this.props;
    const token = storeWithExpiration.get('token');
    listBatchesAction(token, jobId);
  };

  render() {
    const { superadmin } = this.props;
    return (
      <div>
        <JobsPage jobs={superadmin.get('jobs')} getJobBatchesFunction={this.getJobBatches} />
        <BatchesPage batches={superadmin.get('batches')} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { superadmin } = state;
  return { superadmin };
}

export default connect(mapStateToProps, {
  listJobsAction: listJobs,
  listBatchesAction: listBatches,
})(JobsPageContainer);
